import { makeStyles } from "tss-react/mui";
import { Theme247 } from "../styles/Theme247";
import {
  Breadcrumbs,
  Button,
  Card,
  CardActionArea,
  CardHeader,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import { ReactComponent as EuroSvg } from "../assets/Euro.svg";
import i18n from "../reducers/i18n";
import { useEffect, useRef, useState } from "react";
import { ApplyStyle as _s } from "../utils/ApplyStyle";
import { withCurrentAccountPrefix } from "../utils/accountMode";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ScopeHeader from "../components/ScopeHeader";
import clsx from "clsx";
import { ReactComponent as EquipmentPhotoWrapper } from "../assets/EquipmentPhotoWrapper.svg";
import { ReactComponent as UptimeSvg } from "../assets/uptimeSvg.svg";
import { ReactComponent as EmptyCamera } from "../assets/EmptyCamera.svg";
import { ReactComponent as FileUpload } from "../assets/FileUpload.svg";

import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

import { ReactComponent as NewDelete } from "../assets/newDelete.svg";
import { config_UPTIME } from '../Constants';
import { getFileExtention, images_enum } from "../utils/helpers";
import store from "../store";
import axios from "axios";
import { connect } from "react-redux";
import { YearCalendar } from '@mui/x-date-pickers/YearCalendar';

import { createmachine, updatemachine, getSingleMachine } from "../actions/machines";

import { getenterpriseswithtypes, getLegalEntities } from '../actions/machines';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import { v4 as uuidv4 } from 'uuid';
import QRCode from 'qrcode';
import QRRCode from "react-qr-code";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import logo from './logo.png';
import { createBrand, createLegalEntity, createType, deletemachine } from "../actions/machines"
import CreatableSelect from 'react-select/creatable';
import { Box, flexbox } from "@mui/system";
import moment from "moment";
import { ReactComponent as RoundedDeleteSvg } from "../assets/roundedDelete.svg";
import DeletePopUp from "../components/DeletePopup";

import {
  getsitesareaeqs2,
  getallsitesareaeqs,
  createAreaShifts,
  updateAreaShifts
} from "../actions/objects";
import { getItem } from "../utils/DataProtection";
import { Add } from "@mui/icons-material";
import ShiftsModel from "./ShiftsModel";

const getLocalizedTextValue = (value, language) => {
  if (!value) {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  if (typeof value === "object") {
    return (
      value?.[language] ||
      value?.de ||
      value?.en ||
      value?.fr ||
      Object.values(value).find((entry) => typeof entry === "string" && entry) ||
      ""
    );
  }

  return "";
};

export default connect(
  ({ allsitesareaseqs, enterprises, legalEntities, machines }) => ({
    allsitesareaseqs,
    machines,
    enterprises, legalEntities
  }),
  { createmachine, getSingleMachine, createAreaShifts,updateAreaShifts, getsitesareaeqs2, getallsitesareaeqs, getenterpriseswithtypes, deletemachine, getLegalEntities, createLegalEntity, createBrand, createType, updatemachine }
)((props) => {

  const navigate = useNavigate();

  const useStyles = makeStyles()((theme) => ({
    elevatedSection: {
      ...Theme247.elevatedSection,
    },
  }));

  const markenNameRef = useRef();
  const typbezeichnungRef = useRef();
  const herstellerRef = useRef();


  const location = useLocation();

  let defaultAreaNodeId = "";
  let defaultSiteId = "";
  let defaultEquipmentId = "";


  props.allsitesareaseqs[0]?.data[0]?.legalentity?.hassite && props.allsitesareaseqs[0]?.data[0]?.legalentity?.hassite.map((st) => {
    st.site?.hasarea && st.site?.hasarea.map((area) => {
      if (area.area.nodeid === location?.state?.nodeid) {
        defaultAreaNodeId = area.area.nodeid + "$" + area.area.name;
        defaultSiteId = st.site.nodeid + "$" + st.site.name;
      }
    })
  })

  props.allsitesareaseqs[0]?.data[0]?.legalentity?.hasequipmentpool && props.allsitesareaseqs[0]?.data[0]?.legalentity?.hasequipmentpool.map((eq) => {
    if (eq.equipmentpool.nodeid === location?.state?.nodeid) {
      defaultEquipmentId = eq.equipmentpool.nodeid + "$" + eq.equipmentpool.name;
    }
  })

  const { classes } = useStyles();


  const [land, setLand] = useState("");

  const [mediaLinks, setMediaLinks] = useState([]);

  const [area, setArea] = useState(defaultAreaNodeId);
  const [site, setSite] = useState(defaultSiteId);

  const [uploadurl, setuploadurl] = useState("");

  const [isIdentical, setIsIdentical] = useState("");

  const [anchorEl, setAnchorEl] = useState();


  const [dimension_width, set_dimension_width] = useState("");
  const [dimension_height, set_dimension_hight] = useState("");
  const [dimension_depth, set_dimension_depth] = useState("");
  const [electricPower, set_electric_power] = useState("");

  const [widthError, setWidthError] = useState("");
  const [heightError, setHeightError] = useState("");
  const [depthError, setDepthError] = useState("");

  const [weekShifts, setWeekShifts] = useState([]);

  const [steuerung_softwarestand, set_steuerung_softwarestand] = useState("");
  const [steuerung_type, set_steuerung_type] = useState("");
  const [steuerung_hersteller, set_steuerung_hersteller] = useState("");

  const [betriebszeiten, setBetriebszeiten] = useState("");

  const [typenschildPhoto, setTypenschildPhoto] = useState("");

  const [typenschildPhotoObj, setTypenschildPhotoObj] = useState("");
  const [equipmentPhotoObj, setEquipmentPhotoObj] = useState("");
  const [equipmentPhoto, setEquipmentPhoto] = useState("");


  const [nodeid, setnodeid] = useState();

  const [internerName, setInternerName] = useState("");

  const [mediaLinkParent, setMediaLinkParent] = useState("");


  const [equipmentId, setEquipmentId] = useState("");

  const [eqStunde, setEqStunde] = useState();

  const [inventoryId, setInventoryId] = useState("");

  const [costcenter, setCostCenter] = useState("");


  const [constructionDate, setConstructionDate] = useState("");

  const [manufacturerSerialNumber, setManufacturerSerialNumber] = useState("");

  const [testBook, setTestBook] = useState("");

  const [openDialogDelete, setopenDialogDelete] = useState(false)

  const handleDialogDelete = () => {
    setopenDialogDelete(false)
  }

  const [equipmenttypenodeid, setequipmenttypenodeid] = useState("");

  const [brand, setbrand] = useState(null);

  const [mimeTypeNP, setMimeTypeNP] = useState();
  const [fileIdNP, setFileIdNP] = useState();

  const [fileId, setFileId] = useState();

  const [fileid, setfileid] = useState('');

  const [uploadUrlNP, setUploadUrlNP] = useState()
  const [childImageNP, setChildImageNP] = useState()
  const [bucketIdNP, setbucketIdNP] = useState()
  const [attachmentNodeidNP, setAttachmentNodeidNP] = useState()
  const [attachmentNodeid, setattachmentNodeid] = useState()

  const [fileVersionNP, setFileVersionNP] = useState()

  const [eqPool, setEqPool] = useState("");

  const [mimetype, setmimetype] = useState("");

  const [bucketid, setbucketid] = useState('')
  const [fileVersion, setFileVersion] = useState('')

  const [types, settypes] = useState("");

  const [model, setmodel] = useState(null);

  const [selectedDate, setSelectedDate] = useState("");

  const [selectedDatum, setSelectedDatum] = useState();

  const [datum, setDatum] = useState("");

  const [legalEntityNodeId, setLegalEntityNodeId] = useState(null);

  const [typePreviewModel, setTypePreviewModel] = useState(false);

  const [formError, setFormError] = useState([]);

  const [targetLegalEntity, setTargetLegalEntity] = useState(null);

  const [locationEquipment, setLocationEquipment] = useState(null);

  const [editMode, setEditMode] = useState(false);

  const [loading, setLoading] = useState(false);


  const getExistingShifts = (data) => {
    // preparing pre load data
    return data.map((shift) => {
      let start_time = new Date(shift[1]).toLocaleTimeString();
      let start_hours = start_time.split(":")[0];
      let start_minutes = start_time.split(":")[1];

      start_time = start_hours + ":" + start_minutes;

      let end_time = new Date(shift[2]).toLocaleTimeString();
      let end_hours = end_time.split(":")[0];
      let end_minutes = end_time.split(":")[1];

      end_time = end_hours + ":" + end_minutes;

      return {
        start: start_time,
        end: end_time,
        unmanned: shift[4],
        weekdays: shift[3],
        startUnix: timeToMilliseconds(start_time),
        endUnix: timeToMilliseconds(end_time),
      };
    });
  };


  useEffect(() => {

    let width_error = validateNumber(dimension_width);
    let height_error = validateNumber(dimension_height);
    let depth_error = validateNumber(dimension_depth);

    setWidthError(width_error)

    setHeightError(height_error)

    setDepthError(depth_error)

  }, [dimension_width, dimension_depth, dimension_height])

  useEffect(() => {
    props.getSingleMachine(location?.state?.equipment?.nodeid);
    props.getenterpriseswithtypes();
    props.getallsitesareaeqs("", "ALL_SAE")
    props.getLegalEntities("GET_LEGALENTITY");
    setFileId(location?.state?.equipment?.image?.fileid)
    setFileIdNP(location?.state?.equipment?.typenameplate?.fileid)

    if (location?.state?.pageType == 'add') {
      setnodeid(uuidv4())
    } else if (location?.state?.pageType == 'edit') {
      setEditMode(true);


      if (location.state.equipment?.costcenter !== null) {
        setCostCenter(location.state.equipment?.costcenter[store.getState().language]);
      }
      setTestBook(location.state.equipment?.inspectionbooknumber);

      if (location.state.equipment?.dimensions !== null) {
        set_dimension_width(location.state.equipment?.dimensions[0]);
        set_dimension_hight(location.state.equipment?.dimensions[1]);
        set_dimension_depth(location.state.equipment?.dimensions[2]);
      }

      set_electric_power(location.state.equipment?.electricalpower);

      if (location.state.equipment?.controllerinformation !== null) {

        set_steuerung_hersteller(location.state.equipment?.controllerinformation[0]);
        set_steuerung_type(location.state.equipment?.controllerinformation[1]);
        set_steuerung_softwarestand(location.state.equipment?.controllerinformation[3]);

      }

      if (location.state.equipment?.hourlyrate !== null) {
        setEqStunde(location.state?.equipment?.hourlyrate[0]);
      }

      setSelectedDatum(+location.state.equipment?.commissioningdate);
      setDatum(+location.state.equipment?.commissioningdate);

      let links = [];

      if (location.state.equipment?.mediasupply?.length) {
        if (location.state.equipment?.mediasupply[0][store.getState().language] !== "") {
          location?.state?.equipment?.mediasupply.map((link) => {
            links.push({
              id: uuidv4(),
              text: link[store.getState().language]
            })
          })
        }
      }

      setMediaLinks(links)

      let eq = location.state?.equipment;
      if (eq) {
        /* console.log(eq, "eq") */
        setLocationEquipment(location.state?.equipment)
        setnodeid(location.state?.equipment?.nodeid)
        setInternerName(
          getLocalizedTextValue(eq.name, store.getState().language)
        )
        setEquipmentId(eq.equipmentid);
        setInventoryId(eq.inventoryid);
        setManufacturerSerialNumber(eq.manufacturerserialnumber);
        setSelectedDate(+eq.constructiondate);
        setConstructionDate(+eq.constructiondate);

        if (eq?.hasequipmenttype) {

          setLegalEntityNodeId({
            label:
              eq?.hasequipmenttype[0] &&
              getLocalizedTextValue(
                eq.hasequipmenttype[0]?.equipmenttype?.isequipmenttypeof[0]?.brand?.isbrandof[0]?.legalentity?.name,
                store.getState().language
              ),
            value: eq?.hasequipmenttype[0] && eq.hasequipmenttype[0]?.equipmenttype?.isequipmenttypeof[0]?.brand?.isbrandof[0]?.legalentity?.nodeid,
          })

          setbrand({
            label:
              eq?.hasequipmenttype[0] &&
              getLocalizedTextValue(
                eq?.hasequipmenttype[0]?.equipmenttype?.isequipmenttypeof[0]?.brand?.name,
                store.getState().language
              ),
            value: eq?.hasequipmenttype[0] && eq?.hasequipmenttype[0]?.equipmenttype?.isequipmenttypeof[0]?.brand?.nodeid
          })

          setmodel({
            label: eq?.hasequipmenttype[0] && eq?.hasequipmenttype[0]?.equipmenttype?.model,
            value: eq?.hasequipmenttype[0] && eq?.hasequipmenttype[0]?.equipmenttype?.model?.nodeid
          });
        }



        setEqPool(
          eq.isequipmentof[0] && eq.isequipmentof[0]?.equipmentpool
            ? eq.isequipmentof[0]?.equipmentpool.nodeid +
                "$" +
                getLocalizedTextValue(
                  eq.isequipmentof[0]?.equipmentpool.name,
                  store.getState().language
                )
            : ""
        );
        setArea(
          eq.isequipmentof[1] && eq.isequipmentof[1]
            ? eq.isequipmentof[1]?.area?.nodeid +
                "$" +
                getLocalizedTextValue(
                  eq.isequipmentof[1]?.area?.name,
                  store.getState().language
                )
            : ""
        );
        setSite(
          eq.isequipmentof[1]
            ? eq.isequipmentof[1]?.area?.isareaof[0]?.site?.nodeid +
                "$" +
                getLocalizedTextValue(
                  eq.isequipmentof[1]?.area?.isareaof[0]?.site?.name,
                  store.getState().language
                )
            : ""
        );

        if (eq.image && Object.keys(eq.image).length) {
          setEquipmentPhoto(eq.image.url);
          setfileid(eq.image.fileid);
          setmimetype(eq.image.mimetype);
          setbucketid(eq.image.bucketid);
          setFileVersion(eq.image.fileversion);
        }

        if (eq.typenameplate && Object.keys(eq.typenameplate).length) {
          setTypenschildPhoto(eq?.typenameplate?.url);
          setFileIdNP(eq.typenameplate.fileid);
          setMimeTypeNP(eq.typenameplate.mimetype);
          setbucketIdNP(eq.typenameplate.bucketid);
          setFileVersionNP(eq.typenameplate.fileversion);
        }


        if (eq.hasshiftmodel) {
          let shifts = eq.hasshiftmodel[0].shiftmodel.shifts;
          if (shifts.length) {
            let data = getExistingShifts(shifts);
            if (data.length) {
              setWeekShifts(data);
            }
          }
        }

        // fileid: fileid,
        // mimetype: mimetype,
        // bucketid: bucketid,
        // fileversion: fileVersion
      }
    }
  }, []);


  useEffect(() => {
    if (brand !== null && Object.keys(brand).length && editMode && props?.enterprises?.length) {
      const found = props?.enterprises?.length && props.enterprises.filter(member => member?.brand?.nodeid == brand.value);
      const types = found.length ? found[0].brand.hasequipmenttype : [];
      settypes(types)
    }
  }, [props?.enterprises, brand]);


  useEffect(() => {
    let errorArray = [];

    if (brand === null || Object.keys(brand).length === 0) {
      errorArray.push("brandError")
    }
    if (model === null || Object.keys(model).length === 0) {
      errorArray.push("modelError");
    }
    if ((legalEntityNodeId === null || Object.keys(legalEntityNodeId).length === 0) && !isIdentical) {
      errorArray.push("legalEntityError");
    }

    setFormError(errorArray)

  }, [brand, model, legalEntityNodeId, isIdentical])


  const handleAddMediaLinks = () => {
    let links = [...mediaLinks];
    links.push({
      id: uuidv4(),
      text: ""
    });
    setMediaLinks(links)
  }

  const handleChildMediLinksChange = (text, id) => {
    const index = mediaLinks.findIndex((media) => media.id === id);
    if (index !== -1) {
      const updatedLinks = [...mediaLinks];
      updatedLinks[index] = {
        ...updatedLinks[index],
        text: text
      };
      setMediaLinks(updatedLinks);
    }
  }

  const handleDeleteChildMediaLinks = (id) => {
    setMediaLinks((prevLinks) =>
      prevLinks.filter((link) => link.id !== id)
    );
  }

  const handleSubmit = async () => {

    // setLoading(true);

    if (formError.length) {
      return;
    }

    const legalentitynodeid = JSON.parse(getItem('legalentitynodeid'));
    const equipmentnodeid = config_UPTIME.url.UPTIME_DEFAULT_URL + nodeid;
    let legalEntityNodeId_uid = config_UPTIME.url.UPTIME_DEFAULT_URL + uuidv4();
    let model_uid = config_UPTIME.url.UPTIME_DEFAULT_URL + uuidv4();
    let brand_uid = config_UPTIME.url.UPTIME_DEFAULT_URL + uuidv4();


    let image;
    let typenameplate;
    if (equipmentPhoto != undefined) {
      let url = uploadurl;
      const config = {
        headers: {
          'Content-Type': equipmentPhotoObj.type,
          'Access-Control-Allow-Origin': '*'
        }
      }

      const response = await axios.put(url, equipmentPhotoObj, config)
        .then(res => {
          // console.log(res)
        })
        .catch(function (error) {
          console.log(error);
        });

      image = {
        fileid: fileid,
        mimetype: mimetype,
        bucketid: bucketid,
        fileversion: fileVersion
      }


    }

    if (typenschildPhotoObj != undefined) {
      const configNP = {
        headers: {
          'Content-Type': typenschildPhotoObj.type,
          'Access-Control-Allow-Origin': '*'
        }
      }
      let url = uploadUrlNP
      const response101 = await axios.put(url, typenschildPhotoObj, configNP)
        .then(res => {
          // console.log(res)
        })
        .catch(function (error) {
          console.log(error);
        });


      typenameplate = {
        fileid: fileIdNP,
        mimetype: mimeTypeNP,
        bucketid: bucketIdNP,
        fileversion: fileVersionNP
      }
    }

    let isequipmentofPayload = [];

    if (eqPool?.split("$")[0] !== "") {
      isequipmentofPayload.push(eqPool?.split("$")[0]);
    }
    if (area?.split("$")[0] !== "") {
      isequipmentofPayload.push(area?.split("$")[0],);
    }

    let mediaSupply = mediaLinks.length ? mediaLinks.filter((media) => { return media.text !== "" }) : [];

    let d_width = dimension_width;
    let d_height = dimension_height;
    let d_depth = dimension_depth;

    let dimensionss = [0, 0, 0];

    if (d_width === "" && d_height === "" && d_depth === "") {
      dimensionss = undefined;
    } else {
      dimensionss = [+d_width, +d_height, +d_depth];
    }


    let addPayload = {

      lang: store.getState().language,
      name: internerName,
      equipmentid: equipmentId,
      inventoryid: inventoryId,
      constructiondate: constructionDate,
      manufacturerserialnumber: manufacturerSerialNumber,
      isequipmentof: [
        ...isequipmentofPayload,
        legalentitynodeid
        // isIdentical ? brand?.value : legalEntityNodeId.__isNew__ ? legalEntityNodeId_uid : legalEntityNodeId.value,
        // model?.__isNew__ ? model_uid : model.value
      ],
      equipmenttypenodeid: model?.__isNew__ ? model_uid : model.value,
      image: image,
      typenameplate: typenameplate,
      equipmentnodeid: equipmentnodeid,
      assign: {
        payload: [{
          isequipmentof: isequipmentofPayload,
          deleteequipmentof: [],
        }]
      },

      legalentity: {
        isnew: legalEntityNodeId.__isNew__ ? true : false,
        name: legalEntityNodeId.label,
        nodeid: legalEntityNodeId.__isNew__ ? legalEntityNodeId_uid : legalEntityNodeId.value
      },
      brand: {
        isnew: brand.__isNew__ ? true : false,
        nodeid: brand.__isNew__ ? brand_uid : brand.value,
        name: brand.label,
        isbrandof: legalEntityNodeId.__isNew__ ? legalEntityNodeId_uid : legalEntityNodeId.value
      },
      equipmenttype: {
        isnew: model.__isNew__ ? true : false,
        model: model.value,
        nodeid: model_uid,
        brandnodeid: brand.__isNew__ ? brand_uid : brand.value
      },

      costcenter: costcenter,
      inspectionbooknumber: testBook,
      commissioningdate: datum === "" ? dayjs(new Date()).unix() * 1000 : datum,
      dimensions: dimensionss,
      electricalpower: electricPower,
      mediasupply: mediaSupply.length ? mediaSupply.map((supply) => { return supply.text }) : [""],
      controllerinformation: [steuerung_hersteller, steuerung_type, "", steuerung_softwarestand],
      hourlyrate: [+eqStunde, { unitid: "EUR", namespace: "https://www.iso.org/iso-4217-currency-codes" }]

    }

    let editPayload = {
      lang: store.getState().language,
      name: internerName,
      equipmentid: equipmentId,
      inventoryid: inventoryId,
      constructiondate: constructionDate,
      manufacturerserialnumber: manufacturerSerialNumber,
      // isequipmentof: [
      // legalentitynodeid
      // isIdentical ? brand?.value : legalEntityNodeId.__isNew__ ? legalEntityNodeId_uid : legalEntityNodeId.value,
      // model?.__isNew__ ? model_uid : model.value
      // ],
      // equipmenttypenodeid: model?.__isNew__ ? model_uid : model.value,
      image: image,
      typenameplate: typenameplate,
      equipmentnodeid: nodeid,

      costcenter: costcenter,
      inspectionbooknumber: testBook,
      commissioningdate: datum === "" ? dayjs(new Date()).unix() * 1000 : datum,
      dimensions: dimensionss,
      electricalpower: electricPower,
      mediasupply: mediaSupply.length ? mediaSupply.map((supply) => { return supply.text }) : [""],
      controllerinformation: [steuerung_hersteller, steuerung_type, "", steuerung_softwarestand],
      hourlyrate: [+eqStunde, { unitid: "EUR", namespace: "https://www.iso.org/iso-4217-currency-codes" }]

    }



    /* if (legalEntityNodeId.__isNew__) {
      await props.createLegalEntity({
        name: legalEntityNodeId.label,
        nodeid: legalEntityNodeId_uid
      });
    }

    if (brand.__isNew__) {
      await props.createBrand({
        nodeid: brand_uid,
        name: brand.value,
        isbrandof: legalEntityNodeId.__isNew__ ? legalEntityNodeId_uid : legalEntityNodeId.value
      });
    }

    if (model.__isNew__) {
      await props.createType({
        model: model.value,
        nodeid: model_uid,
        brandnodeid: brand.__isNew__ ? brand_uid : brand.value
      });
    } */

    let shifts = makeShiftsPayload(weekShifts);

    if (shifts.length && !location?.state?.equipment?.hasshiftmodel) {
      props.createAreaShifts({
        shifts: shifts,
        shiftmodelof: editMode ? nodeid : equipmentnodeid,
      });
    }

    // update shifts to shifts model

    if (location?.state?.equipment?.hasshiftmodel) {
      props.updateAreaShifts({
        shifts: shifts,
        shiftnodeid: location?.state?.equipment?.hasshiftmodel[0].shiftmodel.nodeid,
      });
    }


    if (editMode) {
      await props.updatemachine(editPayload)
    }
    else {
      await props.createmachine(addPayload)
    }

    props.getsitesareaeqs2("", "SAE2");

    if (site !== "" && eqPool === "") {
      navigate(
        withCurrentAccountPrefix("/sites?sitenodeid=" + site.split("$")[0])
      )
    }
    else {
      navigate(withCurrentAccountPrefix("/machines"));
    }

  }


  const receiveChildValue = (value) => {
    const fileid = value[0]
    const uploadurl = value[1]
    const child_image = value[2]

    setmimetype(child_image.type)
    setfileid(fileid)
    setuploadurl(uploadurl)
    setEquipmentPhotoObj(child_image)
    setbucketid(value[3])
    setattachmentNodeid(value[4])
    setFileVersion(value[5]);
  };


  const handleEqStunde = (e) => {
    setEqStunde(e.target.value);
  };


  const handleNewImageMP = e => {
    e.preventDefault();
    var image = e.target.files[0];

    const exstention = getFileExtention(image?.type);
    if (e.target.files.length > 0) {
      const file = URL.createObjectURL(e.target.files[0]);
      setEquipmentPhoto(file);
      setEquipmentPhotoObj(image);
    }
    const user_token = getItem("user");
    const url = config_UPTIME.url.API_URL + "/files";
    const method = "POST";
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(user_token)
      }
    }

    const exstension_payload = []
    if (location?.state?.pageType == 'edit') {
      exstension_payload.push({ nodeid: nodeid, "extension": exstention, "fileid": fileId })
    }
    else {
      exstension_payload.push({ nodeid: config_UPTIME.url.UPTIME_DEFAULT_URL + nodeid, "extension": exstention })
    }

    const response = axios.post(url, {
      count: 1,
      extensions: exstension_payload
    }, config)
      .then(res => {
        var arr = []
        const fileid = res.data[0].fileid;
        const uploadurl = res.data[0].url;
        const bucketid = res.data[0].bucketid;
        arr.push(fileid)
        arr.push(uploadurl)
        arr.push(image)
        arr.push(bucketid)
        arr.push(nodeid)
        arr.push(res.data[0].fileversion)
        receiveChildValue(arr)
        return res;
      })
      .catch(function (error) {
        //console.log(error);
      });
    return response;


  }

  const handleNewImageNP = e => {
    e.preventDefault();
    var image = e.target.files[0];
    const exstention = getFileExtention(image?.type);
    if (e.target.files.length > 0) {
      const file = URL.createObjectURL(e.target.files[0]);
      setTypenschildPhoto(file)
      setTypenschildPhotoObj(image)
    }
    const user_token = getItem("user");
    const url = config_UPTIME.url.API_URL + "/files";
    const method = "POST";
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(user_token)
      }
    }
    //const nodeid=uuidv4();
    const exstension_payload = []
    if (location?.state?.pageType == 'edit') {
      exstension_payload.push({ nodeid: nodeid, "extension": exstention, "fileid": fileIdNP })
    }
    else {
      exstension_payload.push({ nodeid: config_UPTIME.url.UPTIME_DEFAULT_URL + nodeid, "extension": exstention })
    }

    const response = axios.post(url, {
      count: 1,
      extensions: exstension_payload
    }, config)
      .then(res => {
        var arr = []
        const fileid = res.data[0].fileid;
        const uploadurl = res.data[0].url;
        const bucketid = res.data[0].bucketid;
        arr.push(fileid)
        arr.push(uploadurl)
        arr.push(image)
        arr.push(bucketid)
        arr.push(nodeid)
        arr.push(res.data[0].fileversion)
        receiveChildValueTypeNamePlate(arr)
        return res;
      })
      .catch(function (error) {
        //console.log(error);
      });
    return response;
  }

  const receiveChildValueTypeNamePlate = (value) => {
    const fileid = value[0]
    const uploadurl = value[1]
    const child_image = value[2]

    setMimeTypeNP(child_image.type);
    setFileIdNP(fileid)
    setUploadUrlNP(uploadurl)
    setTypenschildPhotoObj(child_image)
    setbucketIdNP(value[3])
    setAttachmentNodeidNP(value[4])
    setFileVersionNP(value[5]);
  };


  const handleDateChange = (date) => {
    const ts = dayjs(date).unix() * 1000;
    setConstructionDate(ts)
    setSelectedDate(dayjs(date));
  };

  const handleDatumChange = (date) => {
    const ts = dayjs(date).unix() * 1000;
    setDatum(ts)
    setSelectedDatum(dayjs(date));
  };

  const handleDeleteTypenschild = () => {
    setTypenschildPhoto("");
    setTypenschildPhotoObj();
  }


  const generateQR = async text => {
    try {
      return await QRCode.toDataURL(text)
    } catch (err) {
      console.error(err)
    }
  }

  const name = internerName;

  const styless = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
    },
    image: {
      marginVertical: 10,
      marginHorizontal: 220,
      width: 100
    },
    qrCode: {
      height: 300, width: 300, marginHorizontal: 120, marginVertical: 5
    },
  });

  const MyDoc = () => (

    <Document>
      <Page style={styless.body}>

        <Image style={styless.image} src={logo} />

        <Image src={generateQR(config_UPTIME.url.UPTIME_DEFAULT_URL + nodeid)} style={styless.qrCode} />

        <Text style={styless.subtitle}>
          {name}
        </Text>

        <Text style={styless.subtitle}>
          {brand?.label}  {model?.label}
        </Text>

      </Page>
    </Document>

  );


  const handleMarkenNameChange = (e) => {
    markenNameRef.current.blur();
    setTargetLegalEntity(null);


    if (e === null) {
      setbrand("");
      if (model !== null && !model.__isNew__) {
        settypes("")
      }
      setmodel("")
      setequipmenttypenodeid(null)
      return;
    }
    else if (e.__isNew__) {
      if (model !== null && !model.__isNew__) {
        setmodel("");
      }
      settypes("")
    }
    setbrand(e);


    props.legalEntities && props.legalEntities.length > 0 && props.legalEntities.map((entity, key) => {
      entity?.legalentity?.hasbrand && entity?.legalentity?.hasbrand.map((brand, key) => {
        if (e.value === brand?.brand?.nodeid) {
          setTargetLegalEntity({
            label: entity.legalentity.name,
            value: entity.legalentity.nodeid
          })
        }
      })
    })

    if (!e.__isNew__) {
      const found = props.enterprises.filter(member => member?.brand?.nodeid == e?.value);
      const types = found[0].brand.hasequipmenttype;
      settypes(types)
    }
  }

  let locale = store.getState().language;
  const validateNumber = (input) => {
    const regex =
      locale === "en" ? /^[0-9,]*\.?[0-9]*$/ : /^[0-9.]*,?[0-9]*$/;

    if (input === "" || input === undefined || input === null) {
      return { error: false, text: "" }
    }

    else if (!regex.test(input)) {
      return { error: true, text: "Ungültiges Zahlenformat" }
    }
    if (+input < 0) {
      return { error: true, text: "Wert muss >= 1 sein" }
    }
    else {
      return { error: false, text: "" }
    }
  }


  const handleModelChange = (e) => {
    typbezeichnungRef.current.blur();
    if (e === null) {
      setmodel({})
      return;
    }
    setmodel(e)
    setequipmenttypenodeid(e.value)
  }

  const handleChangeLegalEntityNodeId = (e) => {
    herstellerRef.current.blur();
    setLegalEntityNodeId(e);

    if (e === null) {
      // setbrand(null);
      // settypes("");
      // setmodel("")
    }
  }


  const handleCloseTypePreviewModel = () => {
    setTypePreviewModel(false);
  }

  const handleTypeInputClick = (e) => {
    e.stopPropagation();
  }

  const handleChangeCheckBox = (e) => {
    let isChecked = e.target.checked;
    setIsIdentical(isChecked);

    if (isChecked) {
      setLegalEntityNodeId(null);
    }

  }

  const handleLabelClick = () => {
    if (typenschildPhoto !== "") {
      setTypePreviewModel(true);
    }
  }

  let allLegalEntities = props.legalEntities && props.legalEntities.length > 0 ? props.legalEntities.map((entity, key) => {
    return {
      label: getLocalizedTextValue(
        entity?.legalentity?.name,
        store.getState().language
      ),
      value: entity?.legalentity?.nodeid
    }
  }) : [];

  let allbrands = [];

  props.legalEntities && props.legalEntities.length > 0 && props.legalEntities.map((entity, key) => {
    entity?.legalentity?.hasbrand && entity?.legalentity?.hasbrand.map((brand, key) => {
      allbrands.push({
        label: getLocalizedTextValue(
          brand?.brand?.name,
          store.getState().language
        ),
        value: brand?.brand?.nodeid,
        legalEntityNodeId: entity.nodeid
      })
    })
  })

  let targetBrands = [];

  if (legalEntityNodeId) {
    let targetEntity = props.legalEntities && props.legalEntities.filter((x, key) => {
      return x.legalentity.nodeid === legalEntityNodeId.value
    });
    if (targetEntity.length) {
      targetBrands = targetEntity[0].legalentity.hasbrand.map((brand => {
        return {
          label: getLocalizedTextValue(
            brand.brand.name,
            store.getState().language
          ),
          value: brand.brand.nodeid
        }
      }));
    }
  }

  /* console.log(location?.state?.equipment) */

  const handleDelete = () => {
    const nodeid = location?.state?.equipment?.nodeid
    props.deletemachine({ nodeid })
    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
    }, 2000)
    navigate(withCurrentAccountPrefix('/dashboard'));
  }

  // Function to convert "HH:MM" to milliseconds
  const timeToMilliseconds = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    let date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    return moment(date).unix() * 1000;
  };

  const getStarEndUnix = (shift) => {
    const { start, end } = shift;

    let startHour = start.split(":")[0];
    let endHour = end.split(":")[0];
    let endMinutes = end.split(":")[1];

    let startShift,
      endShift = 0;

    if (startHour > endHour) {
      // calculate time for next day

      let tempValue = moment(timeToMilliseconds(start)).add(
        24 - Math.abs(startHour - endHour),
        "hour"
      );
      tempValue = new Date(tempValue).setMinutes(endMinutes);
      startShift = timeToMilliseconds(start);
      endShift = moment(tempValue).unix() * 1000;
    } else {
      startShift = timeToMilliseconds(start);
      endShift = timeToMilliseconds(end);
    }
    return { startShift, endShift };
  };

  const makeShiftsPayload = (data) => {
    let result = [];
    if (data.length) {
      result = data.map((shift) => {
        const { startShift, endShift } = getStarEndUnix(shift);
        return [{}, startShift, endShift, shift.weekdays, shift.unmanned];
      });
    }
    return result;
  };


  return (
    <>

      <Dialog onClose={handleCloseTypePreviewModel} open={typePreviewModel}>
        <DialogContent>
          <img src={typenschildPhoto} className="typSchildModelImg" />
          <div className="typSchildModelButton">
            <Button variant="contained" onClick={() => { setTypePreviewModel(false) }}>Schliessen</Button>
          </div>
        </DialogContent>
      </Dialog>
      <Breadcrumbs aria-label="breadcrumb" className={_s(Theme247.breadcrumbs)}>
        <div onClick={() => { navigate(-1) }} style={{ color: "rgba(0, 0, 0, 0.38)", display: "flex" }}>
          <ArrowBackIcon size="large" />
          {i18n().backLink}
        </div>
      </Breadcrumbs>

      <ScopeHeader
        bgColor="var(--color-primary)"
        bgImage="../images/bg1.webp"
        txtColor="#FFFFFF"
        title="Equipment"
        description="Ihr Equipment sind Ihre Maschinen, Geräte und weitere Dinge, die Sie in 247UpTime verwalten möchten."
      />

      <Paper
        elevation={Theme247.elevationLow}
        sx={{ marginBottom: "48px" }}
      // className={classes.elevatedSection}
      >
        <div className={clsx(classes.elevatedSection, "createEquipment")} style={{ marginBottom: "10px", paddingBottom: editMode ? "0px" : "24px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div className="_title" > {
              editMode && location?.state?.equipment?.hasequipmenttype ?
                `${getLocalizedTextValue(
                  location?.state?.equipment?.hasequipmenttype?.[0]?.equipmenttype?.isequipmenttypeof?.[0]?.brand?.name,
                  store.getState().language
                )} ${location?.state?.equipment?.hasequipmenttype?.[0]?.equipmenttype?.model || ""}`.trim()
                : i18n().create_equipment_title
            }
            </div>

            {editMode ? <Button
              size="large"
              variant="outlined"
              onClick={() => { setopenDialogDelete(true) }}
              startIcon={<DeleteForeverOutlinedIcon />}
              style={{
                marginLeft: 21,
                color: "red",
                border: "1px solid #0000001F",
                height: "36px",
                fontSize: "14px",
              }}
            >
              Equipment {i18n().delete}
            </Button> : ""}
          </div>

          {
            editMode ? "" :
              <>
                <Grid container spacing={4} sx={{ marginTop: "0px" }}>
                  <Grid item xs={4.8}  >
                    <FormControl fullWidth >

                      <CreatableSelect
                        inputId="create_equipment_markenName"
                        isLoading={props.legalEntities.length === 0}
                        data-testid="create_equipment_markenName"
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            height: "56px",
                            borderColor: formError.includes("brandError") ? "red" : 'grey',
                          }),
                        }} theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary: "#38748d"

                          }
                        })}
                        ref={markenNameRef} value={brand} onChange={handleMarkenNameChange} className="markenNameSelect" placeholder="Markenname" isClearable options={legalEntityNodeId === null || legalEntityNodeId?.__isNew__ ? allbrands : targetBrands} />
                      <FormHelperText>z.B.: Gildemeister</FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={4.8}>
                    <FormControl fullWidth>


                      <CreatableSelect inputId="create_equipment_type" theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary: "#38748d"

                        }
                      })} styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          height: "56px",
                          borderColor: formError.includes("modelError") ? "red" : 'grey',
                        }),
                      }} ref={typbezeichnungRef} value={model} onChange={handleModelChange} className="modelSelect" placeholder="Typbezeichnung" isClearable options={(types?.length > 0 ? (
                        types.map((x, key) => {
                          return {
                            label: x?.equipmenttype?.model,
                            value: x?.equipmenttype?.nodeid
                          }
                        })) : [])
                      } />

                      <FormHelperText>z.B.: NLX 6000</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={4} sx={{ marginTop: "0px" }}>
                  <Grid item xs={4.8}>
                    <FormControl fullWidth>
                      <CreatableSelect
                        inputId="create_equipment_hersteller_select"
                        isSearchable={brand?.value && brand?.__isNew__ !== undefined}
                        isLoading={props.legalEntities.length === 0}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary: "#38748d"

                          }
                        })} isDisabled={isIdentical} styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            height: "56px",
                            borderColor: formError.includes("legalEntityError") && !isIdentical ? "red" : 'grey',
                          }),
                        }} ref={herstellerRef} value={isIdentical ? brand : legalEntityNodeId} onChange={handleChangeLegalEntityNodeId} className="herstellerCheck" placeholder="Hersteller" isClearable options={brand?.__isNew__ || targetLegalEntity === null ? allLegalEntities : [targetLegalEntity]} />
                      <FormHelperText>z.B.: DMG Mori</FormHelperText>
                    </FormControl>
                  </Grid>


                  {/* <Grid item xs={5} marginTop={1} marginLeft={0}>
                    <FormControlLabel
                      className="identicalCheckbox"
                      label="Hersteller identisch mit Markenname"
                      control={
                        <Checkbox
                          checked={isIdentical}
                          onChange={handleChangeCheckBox}
                        />
                      }
                    />
                  </Grid> */}
                </Grid>

                <br></br>

                <Divider orientation="horizontal" />

              </>
          }

        </div>



        <div className="_fileUploadContainer">
          <div className={clsx(classes.elevatedSection, "createEquipment")} style={{ margin: "0px", paddingTop: "0px" }}>

            <Grid container spacing={4} sx={{ marginTop: "0px" }}>
              <Grid item xs={11.5} >
                <TextField
                  fullWidth
                  id="outlined-helperText"
                  label="Interner Name"
                  helperText="z.B.: Nachbearbeitung Drehteile"
                  value={internerName}
                  onChange={(e) => { setInternerName(e.target.value) }}
                  inputProps={{ "data-testid": "txtf_create_equipment_interner_name" }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={4} sx={{ marginTop: "0px" }}>
              <Grid item xs={5.8}>
                <TextField
                  fullWidth
                  id="outlined-helperText"
                  label="Equipment ID"
                  value={equipmentId}
                  onChange={(e) => { setEquipmentId(e.target.value) }}
                  inputProps={{ "data-testid": "txtf_create_equipment_id" }}
                />
              </Grid>
              <Grid item xs={5.7}>
                <TextField
                  fullWidth
                  id="outlined-helperText"
                  label="Inventory ID"
                  value={inventoryId}
                  onChange={(e) => { setInventoryId(e.target.value) }}
                  inputProps={{ "data-testid": "txtf_create_equipment_inventory_id" }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={4} sx={{ marginTop: "0px" }}>
              <Grid item xs={11.5}>
                <TextField
                  fullWidth
                  id="outlined-helperText"
                  label="Kostenstelle"
                  value={costcenter}
                  onChange={(e) => { setCostCenter(e.target.value) }}
                  inputProps={{ "data-testid": "txtf_create_equipment_inventory_id" }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={4} sx={{ marginTop: "0px" }}>
              <Grid item xs={5.8}>
                <FormControl fullWidth data-testid="create_equipment_date">

                  <LocalizationProvider labelId="demo-simple-select-label"
                    id="demo-simple-select" dateAdapter={AdapterDayjs}>
                    <DatePicker label="Inbetriebnahme-Datum (optional)"
                      onChange={handleDatumChange}
                      value={dayjs(selectedDatum)}
                      views={['year']} disableFuture

                      orientation="portrait"
                      ref={anchorEl}
                      componentsProps={{
                        popper: {
                          popperOptions: {
                            modifiers: [
                              {
                                name: 'flip',
                                options: {
                                  altBoundary: false,
                                  fallbackPlacements: ['right', 'right'],
                                },
                              },
                            ],
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>

                </FormControl>
              </Grid>
              <Grid item xs={5.8}>
                <TextField
                  fullWidth
                  id="outlined-helperText"
                  label="Prüfbuch-Nr. (optional)"
                  value={testBook}
                  onChange={(e) => { setTestBook(e.target.value) }}
                  inputProps={{ "data-testid": "txtf_create_equipment_test_book" }}
                />
              </Grid>
            </Grid>



            <Grid container spacing={4} sx={{ marginTop: "0px" }}>
              <Grid item xs={5.8}>
                <FormControl fullWidth data-testid="create_equipment_date">

                  <LocalizationProvider labelId="demo-simple-select-label"
                    id="demo-simple-select" dateAdapter={AdapterDayjs}>
                    <DatePicker label="Baujahr"
                      onChange={handleDateChange}
                      value={dayjs(selectedDate)}
                      views={['year']} disableFuture

                      orientation="portrait"
                      ref={anchorEl}
                      componentsProps={{
                        popper: {
                          popperOptions: {
                            modifiers: [
                              {
                                name: 'flip',
                                options: {
                                  altBoundary: false,
                                  fallbackPlacements: ['right', 'right'],
                                },
                              },
                            ],
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>

                </FormControl>
              </Grid>
              <Grid item xs={5.8}>
                <TextField
                  fullWidth
                  label="Hersteller-Seriennummer"
                  value={manufacturerSerialNumber}
                  onChange={(e) => { setManufacturerSerialNumber(e.target.value) }}
                  inputProps={{ "data-testid": "txtf_create_equipment_hersteller_sn" }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={4} sx={{ marginTop: "0px" }}>

              <Grid item xs={11.6}>
                <Card className={classes.cardButton} variant="outlined" onClick={handleTypeInputClick} >
                  {typenschildPhoto === "" && <input
                    id="myInput"
                    style={{ display: "none" }}
                    accept={images_enum}
                    type="file"
                    onChange={handleNewImageNP}
                  />}
                  <CardActionArea style={{ display: "flex", justifyContent: "start" }}>
                    <label htmlFor="myInput" style={{ display: "flex", alignItems: "center" }} onClick={handleLabelClick} className="createEqLabel">
                      <CardHeader
                        className="NT_cardHeader"
                        avatar={
                          <Icon color="primary" className={classes.cardIcon}>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_3115_10382"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                              >
                                <rect width="24" height="24" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_3115_10382)">
                                <path
                                  d="M11 18.5C12.25 18.5 13.3127 18.0627 14.188 17.188C15.0627 16.3127 15.5 15.25 15.5 14C15.5 12.75 15.0627 11.6873 14.188 10.812C13.3127 9.93733 12.25 9.5 11 9.5C9.75 9.5 8.68733 9.93733 7.812 10.812C6.93733 11.6873 6.5 12.75 6.5 14C6.5 15.25 6.93733 16.3127 7.812 17.188C8.68733 18.0627 9.75 18.5 11 18.5ZM3 22C2.45 22 1.97933 21.8043 1.588 21.413C1.196 21.021 1 20.55 1 20V8C1 7.45 1.196 6.97933 1.588 6.588C1.97933 6.196 2.45 6 3 6H6.15L7.4 4.65C7.58333 4.45 7.804 4.29167 8.062 4.175C8.32067 4.05833 8.59167 4 8.875 4H13C13.2833 4 13.521 4.09567 13.713 4.287C13.9043 4.479 14 4.71667 14 5V8H3V20H19V11H20C20.1333 11 20.2627 11.025 20.388 11.075C20.5127 11.125 20.621 11.1957 20.713 11.287C20.8043 11.379 20.875 11.4873 20.925 11.612C20.975 11.7373 21 11.8667 21 12V20C21 20.55 20.8043 21.021 20.413 21.413C20.021 21.8043 19.55 22 19 22H3ZM19 6H18C17.7167 6 17.4793 5.90433 17.288 5.713C17.096 5.521 17 5.28333 17 5C17 4.71667 17.096 4.479 17.288 4.287C17.4793 4.09567 17.7167 4 18 4H19V3C19 2.71667 19.096 2.479 19.288 2.287C19.4793 2.09567 19.7167 2 20 2C20.2833 2 20.5207 2.09567 20.712 2.287C20.904 2.479 21 2.71667 21 3V4H22C22.2833 4 22.5207 4.09567 22.712 4.287C22.904 4.479 23 4.71667 23 5C23 5.28333 22.904 5.521 22.712 5.713C22.5207 5.90433 22.2833 6 22 6H21V7C21 7.28333 20.904 7.521 20.712 7.713C20.5207 7.90433 20.2833 8 20 8C19.7167 8 19.4793 7.90433 19.288 7.713C19.096 7.521 19 7.28333 19 7V6Z"
                                  fill="black"
                                  fillOpacity="0.5"
                                />
                              </g>
                            </svg>
                          </Icon>
                        }
                        title={"Typenschild-Foto hinzufügen"}
                      /></label>
                    {typenschildPhoto && <div onClick={handleDeleteTypenschild} style={{ marginLeft: "53%" }}> <NewDelete /></div>}
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>


          </div>
          <div className="cameraImageUploadWrapper">
            {equipmentPhoto?.length ? <img className="bxShadow" src={equipmentPhoto} width={100} height={100} style={{ borderRadius: "50%" }} /> : <EmptyCamera />}
            <input
              id="myInput1"
              style={{ display: "none" }}
              accept={images_enum}
              type="file"
              onChange={handleNewImageMP}
            />
            <label htmlFor="myInput1">
              <FileUpload className="fileUploadSvg" />
            </label>
          </div>
        </div>


        <div className="newFields">

          <Grid container spacing={4} sx={{ marginTop: "-30px" }}>
            <Grid item xs={5.4}>
              <div style={{ display: "flex", padding: "0px 25px" }}>
                <div style={{ marginRight: "15px" }}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="outlined-adornment-amount">
                      Breite
                    </InputLabel>
                    <OutlinedInput
                      type="number"
                      label="Breite"
                      placeholder="Breite"
                      id="outlined-helperText"
                      variant="outlined"
                      error={widthError.error}
                      value={dimension_width}
                      inputProps={{
                        inputMode: 'decimal', // Mobile keyboards show numeric pad with decimal
                      }}
                      onChange={(e) => {
                        set_dimension_width(e.target.value)
                      }}
                      helperText="Pro Equipment überschreibbar"
                      endAdornment={
                        <div style={{ fontSize: "11px", color: "#8A8A8A" }}>
                          mm
                        </div>
                      }
                    />
                  </FormControl>
                </div>
                <div style={{ paddingRight: "15px" }}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="outlined-adornment-amount">
                      Höhe
                    </InputLabel>
                    <OutlinedInput
                      type="number"
                      label="Höhe"
                      placeholder="Höhe"
                      variant="outlined"
                      error={heightError.error}
                      value={dimension_height}
                      onChange={(e) => { set_dimension_hight(e.target.value) }}
                      helperText="Pro Equipment überschreibbar"
                      endAdornment={
                        <div style={{ fontSize: "11px", color: "#8A8A8A" }}>
                          mm
                        </div>

                      }
                    />
                  </FormControl>
                </div>
                <div style={{ paddingRight: "15px" }}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="outlined-adornment-amount">
                      Tiefe
                    </InputLabel>
                    <OutlinedInput
                      type="number"
                      label="Tiefe"
                      placeholder="Tiefe"
                      variant="outlined"
                      error={depthError.error}
                      value={dimension_depth}
                      onChange={(e) => { set_dimension_depth(e.target.value) }}
                      helperText="Pro Equipment überschreibbar"
                      endAdornment={
                        <div style={{ fontSize: "11px", color: "#8A8A8A" }}>
                          mm
                        </div>

                      }
                    />
                  </FormControl>
                </div>

              </div>
            </Grid>
            <Grid item xs={4.0} style={{ padding: "32px 0px 0px 0px" }}>
              <FormControl fullWidth>
                <InputLabel htmlFor="outlined-adornment-amount">
                  Elektrische Leistung (optional)
                </InputLabel>
                <OutlinedInput
                  type="number"
                  label="Elektrische Leistung (optional)"
                  placeholder="Elektrische Leistung (optional)"
                  variant="outlined"
                  value={electricPower}
                  onChange={(e) => { set_electric_power(e.target.value) }}
                  helperText="Pro Equipment überschreibbar"
                  endAdornment={
                    <InputAdornment position="end">
                      kW
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Grid>

          </Grid>


          <div style={{ minHeight: "50px", maxHeight: "276px", overflowY: "auto", display: mediaLinks.length === 0 ? "none" : "block" }}>
            {
              mediaLinks.map((media, index) => {
                return (<Grid container spacing={4} sx={{ marginTop: "0px" }} key={media.id}>
                  <Grid item xs={9.2} sx={{ margin: "0px 0px 0px 24px", display: "flex", alignItems: "center" }}>
                    <TextField
                      fullWidth
                      id="outlined-helperText"
                      label="Medienanschluss (optional)"
                      value={media.text}
                      onChange={(e) => { handleChildMediLinksChange(e.target.value, media.id) }}
                      inputProps={{ "data-testid": "txtf_create_equipment_interner_name" }}
                    />
                    <IconButton color="error" onClick={() => handleDeleteChildMediaLinks(media.id)}>
                      <DeleteForeverOutlinedIcon
                        style={{
                          color: "red",
                          cursor: "pointer",
                        }} />
                    </IconButton>
                  </Grid>
                </Grid>)
              })
            }

            <br></br>
          </div>

          <br></br>

          <Button variant="outlined" sx={{ marginLeft: "25px", height: "40px" }} onClick={handleAddMediaLinks} >
            + Medienanschluss
          </Button>

          <br></br>
          <br></br>


          <Divider orientation="horizontal" />
          <br></br>

          <div className={clsx(classes.elevatedSection, "createEquipment")} style={{ paddingTop: "0px", marginBottom: 0 }}>
            <div className="_title">{"Steuerung"}</div>

            <Grid container spacing={4} sx={{ marginTop: "0px" }}>
              <Grid item xs={4.9}>
                <TextField
                  fullWidth
                  label="Hersteller (optional)"
                  value={steuerung_hersteller}
                  onChange={(e) => { set_steuerung_hersteller(e.target.value) }}
                  inputProps={{ "data-testid": "txtf_create_equipment_hersteller" }}
                />
              </Grid>
              <Grid item xs={4.8}>
                <TextField
                  fullWidth
                  label="Typ (optional)"
                  value={steuerung_type}
                  onChange={(e) => { set_steuerung_type(e.target.value) }}
                  inputProps={{ "data-testid": "txtf_create_equipment_hersteller_typ" }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={4} sx={{ marginTop: "0px" }}>
              <Grid item xs={9.7}>
                <TextField
                  fullWidth
                  label="Softwarestand (optional)"
                  value={steuerung_softwarestand}
                  onChange={(e) => { set_steuerung_softwarestand(e.target.value) }}
                  inputProps={{ "data-testid": "txtf_create_equipment_soft" }}
                />
              </Grid>
            </Grid>

          </div>

          <br></br>
          <Divider orientation="horizontal" />
          <br></br>

        </div>

        {
          editMode ? "" :
            <>
              <div className={clsx(classes.elevatedSection, "createEquipment")} style={{ paddingTop: "0px", marginBottom: 0 }}>
                <div className="_title">{"Equipment zuordnen"}</div>

                <Grid container spacing={4} sx={{ marginTop: "0px" }}>

                  <Grid item xs={9.6}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Equipment Pool</InputLabel>
                      <Select
                        data-testid="drpdwn_create_equipment_pool"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={eqPool}
                        label="Equipment Pool"
                        onChange={(e) => {
                          setEqPool(e.target.value);
                        }}
                        error={eqPool === "" && area === ""}
                      >
                        {
                          props.allsitesareaseqs[0]?.data[0]?.legalentity?.hasequipmentpool && props.allsitesareaseqs[0]?.data[0]?.legalentity?.hasequipmentpool.map((eq) => {
                            return (
                              <MenuItem
                                data-testid="li_create_equipment_pool"
                                value={
                                  eq.equipmentpool.nodeid +
                                  "$" +
                                  getLocalizedTextValue(
                                    eq.equipmentpool.name,
                                    store.getState().language
                                  )
                                }
                              >
                                {getLocalizedTextValue(
                                  eq.equipmentpool.name,
                                  store.getState().language
                                )}
                              </MenuItem>
                            )
                          })
                        }
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>

              <Divider orientation="horizontal" />



              <div className="createEquipment">
                <Grid container spacing={4} sx={{ marginTop: "0px", paddingLeft: "24px" }}>
                  <Grid item xs={4.8} paddingTop={0}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Werk</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={site}
                        label="Werk"
                        onChange={(e) => {
                          setSite(e.target.value);
                        }}
                        data-testid="drpdwn_create_equipment_werk"
                      >
                        {
                          props.allsitesareaseqs[0]?.data[0]?.legalentity?.hassite && props.allsitesareaseqs[0]?.data[0]?.legalentity?.hassite.map((st) => {
                            if (st.site.hasarea) {
                              return (
                                <MenuItem
                                  data-testid="li_create_equipment_werk"
                                  value={
                                    st.site.nodeid +
                                    "$" +
                                    getLocalizedTextValue(
                                      st.site.name,
                                      store.getState().language
                                    )
                                  }
                                >
                                  {getLocalizedTextValue(
                                    st.site.name,
                                    store.getState().language
                                  )}
                                </MenuItem>
                              )
                            }
                          })
                        }
                      </Select>

                    </FormControl>
                  </Grid>

                  <Grid item xs={4.6} marginTop={0} marginLeft={0} >
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Bereich</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={area}
                        label="Bereich"
                        onChange={(e) => {
                          setArea(e.target.value);
                        }}
                        error={eqPool === "" && area === ""}
                        data-testid="drpdwn_create_equipment_area"
                      >
                        {
                          props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite && props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite.map((st) => {
                            return st.site.nodeid === site?.split("$")[0] && st.site.hasarea && st.site.hasarea.map((area) => {
                              return (
                                <MenuItem
                                  data-testid="li_create_equipment_area"
                                  value={
                                    area.area.nodeid +
                                    "$" +
                                    getLocalizedTextValue(
                                      area.area.name,
                                      store.getState().language
                                    )
                                  }
                                >
                                  {getLocalizedTextValue(
                                    area.area.name,
                                    store.getState().language
                                  )}
                                </MenuItem>
                              )
                            })
                          })
                        }
                      </Select>

                    </FormControl>
                  </Grid>
                </Grid>

              </div>

              <br></br>
              <Divider orientation="horizontal" />
            </>
        }
<br></br>
        <div className={clsx(classes.elevatedSection, "createEquipment")} style={{ paddingTop: "0px", marginBottom: -12, padding: "0px 0px 0px 24px" }}>
          <div className="_title">{"Betriebsparameter"}</div>
          <br />
          {/* <FormControlLabel
            sx={{ height: 80 }}
            control={
              <Checkbox
                checked={betriebszeiten}
                onChange={(e) => setBetriebszeiten(e.target.checked)}
              />
            }
            label={
              <div className="ckeckboxLabel" style={{ margin: "20px 0px 21px 0px" }}>
                <div className="title">
                  Einstellungen aus Bereich übernehmen
                </div>
              </div>
            }
          /> */}
        </div>

<br/>

        <div
          style={{ padding: "0px 24px 24px 24px", width: "331px" }}
          className="eq_stunde uiV1"
        >
          <FormControl fullWidth>
            <InputLabel >
              Equipment Stundensatz (optional)
            </InputLabel>
            <OutlinedInput
              type="number"
              id="outlined-helperText"
              label="Equipment Stundensatz (optional)"
              variant="outlined"
              value={eqStunde}
              onChange={handleEqStunde}
              fullWidth
              endAdornment={
                <div style={{ fontSize: "15px", color: "#8A8A8A" }}>
                  €
                </div>

              }
            />
          </FormControl>
        </div>

        <Divider orientation="horizontal" />
        <br/>

        <div className={clsx(classes.elevatedSection, "createEquipment")} style={{ paddingTop: "0px", marginBottom: 0, padding: "0px 0px 0px 24px" }}>
          <div className="_title">{"Betriebszeiten"}</div>
        
          <FormControlLabel
            sx={{ height: 80 }}
            control={
              <Checkbox
                 checked={location?.state?.equipment?.hasshiftmodel ? location?.state?.equipment?.hasshiftmodel[0]?.shiftmodel.shifts.length === 0 : true}
                // onChange={(e) => setBetriebszeiten(e.target.checked)}
              />
            }
            label={
              <div className="ckeckboxLabel" style={{ margin: "20px 0px 21px 0px" }}>
                <div className="title">
                  Einstellungen aus Bereich übernehmen
                </div>
              </div>
            }
          />
        </div>


        <br></br>
        <div style={{ padding: "5px 24px" }} className="eq_stunde ">
          <ShiftsModel weekShifts={weekShifts} setWeekShifts={setWeekShifts} style={{ maxHeight: "10%" }} />
        </div>

        <Divider orientation="horizontal" />


        <div className="stickerWrapper">
          <div>
            <div className="_title">{"Vorschau des Equipments"}</div>
            <div className="equipmentPlateDiv bxShadow">
              <div className="photoWrapper">
                {equipmentPhoto === "" || equipmentPhoto === undefined ? <EquipmentPhotoWrapper /> :
                  <img src={equipmentPhoto} />}
              </div>
              <div className="_contentWrapper">
                <div className="_border"></div>

                <div className="_content">
                  <Tooltip title={internerName}>
                    <div className="eqName1 truncate">
                      {internerName}
                    </div>
                  </Tooltip>

                  <div className="eqName2">
                    {site?.split("$")[1]}
                  </div>
                  <div className="eqSiteName">
                    {area?.split("$")[1]}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="_title">{"Service-Sticker"}</div>
            <div className="equipmentPlateDiv bxShadow">
              <div className="qrCodeWrapper">
                {/* <QrCode /> */}

                <QRRCode
                  size={256}
                  style={{ height: "100%", maxWidth: "100%", width: "100%" }}
                  value={location?.state?.pageType === "add" ? config_UPTIME.url.UPTIME_DEFAULT_URL + nodeid : location?.state?.equipment ? location?.state?.equipment?.nodeid : ""}
                  viewBox={`0 0 256 256`}
                />

              </div>
              <div className="_contentWrapper">

                <div className="_content">
                  <div className="eqName1">
                    <UptimeSvg />
                  </div>
                  <div className="qrTitle1">
                    Hersteller : {isIdentical ? brand?.label : legalEntityNodeId?.label}
                  </div>
                  <div className="qrtitle2">
                    Seriennr: {manufacturerSerialNumber}
                  </div>
                </div>
              </div>
            </div>
            <div className="downloadAsPDF">
              <PDFDownloadLink document={<MyDoc />} fileName={name + '-QRCode.pdf'}>
                {({ loading }) => (loading ? 'Loading document...' : 'Download as PDF')}
              </PDFDownloadLink>
            </div>
          </div>
        </div>



      </Paper>

      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDelete}
        topic="Equipment"
      ></DeletePopUp>

      <Button data-testid="btn_create_equipment_submit" variant="contained" sx={{ textTransform: "uppercase", marginBottom: "24px" }} disabled={formError.length || constructionDate === "" || loading || (!editMode && eqPool === "" && area === "") || widthError.error || heightError.error || depthError.error} onClick={handleSubmit}> <Box sx={{ display: 'flex' }}>
        {loading && <CircularProgress className="EqLoader" />}
      </Box> {loading ? "Ausrüstung erstellen" : editMode ? "SPEICHERN" : "EQUIPMENT anlegen"} </Button>
    </>
  );
})
